import { REWARD_OFFERING } from "../constants";
import CompetitionPage from "../common/components/CompetitionPage";

function WeekOneMain() {
  const offerId = REWARD_OFFERING.weekone;

  return (
    <CompetitionPage 
      offerId={offerId}
    />
  );
}

export default WeekOneMain;